// extracted by mini-css-extract-plugin
export default {"Box":"base-chart-error-module__Box__s_85Y9S"};